// extracted by mini-css-extract-plugin
module.exports = {"cart-icon":"bm_fb","cartIcon":"bm_fb","badge":"bm_fc"};